import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from '../../components/common/Spinner';
import ModalLanguage from '../../components/Modal/ModalLanguage';
import { useTranslation } from 'react-i18next';
import AOS from "aos";
import "aos/dist/aos.css";
import {
  logoutUser,
} from '../../redux/actions';


const Mypage = ( {currentUser, logoutUserAction}) => {
  
  const navigate = useNavigate();
  const { i18n, t} = useTranslation();

  const [isLoaded, setIsLoaded] = useState(false);
  const [user_name, setUserName] = useState('');
  const [user_email, setUserEmail] = useState('');
  const [showLanguageModal, setLanauageModal] = useState(false);

    useEffect(() => {
    AOS.init();
    onInit();
    setUserEmail(currentUser.email);
    setUserName(currentUser.user_name);
  }, []);

  const onInit = async () => {
    setIsLoaded(true);
  }

  const handleLogout = (e) => {
    e.preventDefault();
    logoutUserAction(navigate);
  };

  const linkTo = (link) => {
    navigate('/' + link);
  }

  const gotoHompage = () => {
    
    window.open('http://www.meditoc.io/', "_blank", "noopener, noreferrer");

  };

  return !isLoaded ? (
    <Spinner />
  ) : (
    <section>
      <ModalLanguage show={showLanguageModal} closeModal={() =>{setLanauageModal(false)}}  />
      <div className="taps">
        <div className="tap_bt tapon">My Page</div>
      </div>
      <div className="my_step1">
        <p data-aos="fade-left" data-aos-duration="600">{user_name}<img src="images/icon_eye.svg" alt="" /></p>
        <span data-aos="fade-left" data-aos-duration="800">{user_email}</span>
      </div>
      <div className="my_step2">
        <div className="my_list" data-aos="fade-left" >
          <b> {t('auth.passchange')}</b>
          <span><img onClick={() => linkTo('forgotpassword')} src="images/icon_arr_r.svg" alt="" /></span>
        </div>
        <div className="my_list" data-aos="fade-left" >
          <b> {t('profile.gotohompage')}</b>
          <span><img onClick={gotoHompage} src="images/icon_arr_r.svg" alt="" /></span>
        </div>
        
        <div className="my_list" data-aos="fade-left">
          <b>{t('auth.version')}</b>
          <span>v1.0.1</span>
        </div>
        <div className="my_list" data-aos="fade-left" >
          <b>{t('auth.language')}</b>
          <span onClick={() =>{setLanauageModal(true)}} >
            { i18n.language === 'ko'? t('language.korean'):''}
            { i18n.language === 'en'? t('language.english'):''}
            <img src="images/icon_arr_r.svg" alt="" onClick={() =>{setLanauageModal(true)}}/>
          </span>
        </div>
        <div className="my_list" data-aos="fade-left" onClick={handleLogout} >
          <b className="txtclr">{t('auth.logout')}</b>
          <span><img src="images/icon_logout.svg" alt="" /></span>
        </div>
      </div>
     
    </section>
    
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser, loading } = authUser;
  return {currentUser, loading}
};
const mapActionToProps = {
  logoutUserAction: logoutUser,
};

export default connect(mapStateToProps, mapActionToProps)(Mypage);

